<script lang="ts">
    import { afterNavigate } from '$app/navigation';
    import { onMount } from 'svelte';
    import { page } from '$app/stores';

    let classes = '';
    export { classes as class };

    let alternateLinks: { lang: string; href: string }[] = [];

    afterNavigate(updateAlternateLinks);
    onMount(() => {
        updateAlternateLinks();

        const intervalId = setInterval(updateAlternateLinks, 1000);

        return () => clearInterval(intervalId);
    });

    $: currentLang = $page.url.pathname.slice(1, 3);

    function updateAlternateLinks() {
        const alternateLinkElements = document.querySelectorAll('link[rel="alternate"]');

        alternateLinks = alternateLinkElements
            ? Array.from(alternateLinkElements).map((link) => ({
                  lang: link.getAttribute('hreflang') ?? '',
                  href: link.getAttribute('href') ?? ''
              }))
            : [];
        alternateLinks = alternateLinks.filter(
            (link, index, self) => index === self.findIndex((t) => t.lang === link.lang)
        );
    }
</script>

<div class="{classes} flex items-center h-[20px]">
    {#each alternateLinks as alternateLink, i (alternateLink.lang)}
        <a
            class="mx-2.5 first:ml-0 leading-none {alternateLink.lang === currentLang ? 'text-offwhite' : 'text-neutral-500 hover:text-neutral-400'} transition-colors"
            href={alternateLink.href}
            data-sveltekit-reload>{alternateLink.lang.toUpperCase()}</a
        >
        {#if i < alternateLinks.length - 1}
            <div class="w-[1px] bg-neutral-500 h-5" />
        {/if}
    {/each}
</div>
